import {
  aiAnalyzedFileSchema,
  AiAnalyzedFileSource,
} from "@redotech/ai-core-common/ai-analyzed-file";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getAiAnalyzedFiles = {
  name: "getAiAnalyzedFiles" as const,
  input: z.object({ source: createEnum(AiAnalyzedFileSource).optional() }),
  output: z.object({ data: z.array(aiAnalyzedFileSchema) }),
};

export const getAiAnalyzedFileContent = {
  name: "getAiAnalyzedFileContent" as const,
  input: z.object({ fileUrl: z.string() }),
  output: z.object({ content: z.string() }),
};
